export const POST_TYPE = 'ppfuture_workflow';
export const HTML_ELEMENT_ID = 'future-workflow-editor';

export const FEATURE_FULLSCREEN_MODE = 'fullscreenMode';
export const FEATURE_REDUCED_UI = 'reducedUI';
export const FEATURE_SHOW_ICON_LABELS = 'showIconLabels';
export const FEATURE_INSERTER = 'inserter';
export const FEATURE_MOST_USED_NODES = 'mostUsedNodes';
export const FEATURE_DEVELOPER_MODE = 'developerMode';
export const FEATURE_WELCOME_GUIDE = 'welcomeGuide';
export const FEATURE_ADVANCED_SETTINGS = 'advancedSettings';
export const FEATURE_MINI_MAP = 'miniMap';
export const FEATURE_CONTROLS = 'controls';

export const INSERTER_TAB_TRIGGERS = 'triggers';
export const INSERTER_TAB_ACTIONS = 'actions';
export const INSERTER_TAB_ADVANCED = 'advanced';

export const SLOT_SCOPE_WORKFLOW_EDITOR = 'publishpress-future/edit-workflow';

export const EVENT_DROP_NODE = 'application/future-workflow-editor-node';

export const NODE_TYPE_TRIGGER = 'trigger';
export const NODE_TYPE_ACTION = 'action';
export const NODE_TYPE_ADVANCED = 'advanced';
export const NODE_TYPE_PLACEHOLDER = 'placeholder';

export const HANDLE_TYPE_TARGET = 'target';
export const HANDLE_TYPE_SOURCE = 'source';
